// Small employee avatar. Renders the uploaded photo when present,
// otherwise a circle with the employee's initials — consistent size
// so list rows line up even when photos are mixed with non-photos.
export function Avatar({
  photo,
  firstName,
  lastName,
  size = 28,
  className = "",
}: {
  photo: string | null | undefined;
  firstName?: string | null;
  lastName?: string | null;
  size?: number;
  className?: string;
}) {
  const initials = [(firstName ?? "").trim()[0], (lastName ?? "").trim()[0]]
    .filter(Boolean)
    .join("")
    .toUpperCase() || "·";
  const style = { width: size, height: size };
  if (photo) {
    return (
      <img
        src={photo}
        alt={`${firstName ?? ""} ${lastName ?? ""}`.trim() || "Employee"}
        style={style}
        className={
          "rounded-full object-cover border border-slate-200 bg-slate-100 shrink-0 " + className
        }
      />
    );
  }
  return (
    <div
      style={{ ...style, fontSize: Math.max(10, Math.round(size * 0.38)) }}
      className={
        "rounded-full bg-slate-200 text-slate-600 font-semibold flex items-center justify-center shrink-0 " + className
      }
    >
      {initials}
    </div>
  );
}
